<!-- 停车场基础信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carList": [
                    {
                        "addBy": "admin",
                        "addTime": "20170929160020",
                        "carColor": 0,
                        "carLicenseColor": 0,
                        "carLicenseNumber": "津M95621",
                        "carLicenseType": 0,
                        "carLogo": 0,
                        "carOwnType": 0,
                        "carSeq": 7,
                        "carSizeType": 0,
                        "carType": 0,
                        "customerSeq": 5,
                        "deleted": false,
                        "similarPlates": ""
                    }
                ],
                "cmd": "reportCar",
                "parkCode": "2KM9J7GC",
                "reportTime": "20170929160020"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场基础信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportParkInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场,云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"周期触发（5分钟）",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkPicUrl', info2: '是', info3: 'String', info4: '车场图片链接' },
                        { info1: 'parkChargeRulePicUrl', info2: '是', info3: 'Integer', info4: '车场缴费规则图片链接' },
                        { info1: 'lastUpdateTime', info2: '是', info3: 'String', info4: '最后更新时间，yyyyMMddHHmmss' },
                        { info1: 'pkGlobalid', info2: '是', info3: 'String', info4: 'UUID' },
                        { info1: 'id', info2: '是', info3: 'String', info4: '平台内停车场ID' },
                        { info1: 'fkCarrierid', info2: '是', info3: 'String', info4: '车场图片链接' },
                        { info1: 'parkdigisterkey', info2: '是', info3: 'String', info4: '停车场嘀卡签名的Key' },
                        { info1: 'parkcardkey', info2: '是', info3: 'String', info4: '停车场嘀卡的封口密码' },
                        { info1: 'fkAreaid', info2: '是', info3: 'String', info4: '停车点区域ID' },
                        { info1: 'fkGovernmentid', info2: '是', info3: 'String', info4: '政府ID' },
                        { info1: 'address', info2: '是', info3: 'String', info4: '地址' },
                        { info1: 'picname', info2: '是', info3: 'String', info4: '图片' },
                        { info1: 'slotsnumber', info2: '是', info3: 'String', info4: '停车位数' },
                        { info1: 'freenumber', info2: '是', info3: 'String', info4: '空停车位数' },
                        { info1: 'fkParkingfeeconfigid', info2: '是', info3: 'String', info4: '收费规则ID' },
                        { info1: 'gpsx', info2: '是', info3: 'String', info4: 'Gps的x坐标值' },
                        { info1: 'gpsy', info2: '是', info3: 'String', info4: 'GpsY' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '状态ID' },
                        { info1: 'type', info2: '是', info3: 'String', info4: '路内和路外' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
                        { info1: 'parkname', info2: '是', info3: 'String', info4: '责任人名称' },
                        { info1: 'email', info2: '是', info3: 'String', info4: '邮箱' },
                        { info1: 'description', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'remainPostionNumType', info2: '是', info3: 'String', info4: '剩余车位类型，0：vems 1:mpgs' },
                        { info1: 'remainPostionNum', info2: '是', info3: 'String', info4: '剩余车位数' },
                        { info1: 'mpgsRemainPostionNum', info2: '是', info3: 'String', info4: 'mpgs剩余车位' },
                        { info1: 'carriername', info2: '是', info3: 'String', info4: '' },
                        { info1: 'area', info2: '是', info3: 'String', info4: '区域名称' },
                        { info1: 'linesGpsArray', info2: '是', info3: 'String', info4: '直线GPS集合' },
                        { info1: 'timeoutlength', info2: '是', info3: 'String', info4: '离场过期时长（分钟）' },
                        { info1: 'firstHourCharge', info2: '是', info3: 'String', info4: '首小时收费金额' },
                        { info1: 'partWay', info2: '是', info3: 'String', info4: '停车场参与程度，0:PART（部分参与），1：PAY（可以支付）' },
                        { info1: 'conTel', info2: '是', info3: 'String', info4: '联系电话/车场值班电话' },
                        { info1: 'chargeRuleDisc', info2: '是', info3: 'String', info4: '收费规则描述' },
                        { info1: 'bankName', info2: '是', info3: 'String', info4: '银行名称' },
                        { info1: 'bankCardCode', info2: '是', info3: 'String', info4: '银行卡号' },
                        { info1: 'bankAccountName', info2: '是', info3: 'String', info4: '开户人姓名' },
                        { info1: 'bankAccountMobile', info2: '是', info3: 'String', info4: '汇款通知的手机号' },
                        { info1: 'tempCarports', info2: '是', info3: 'String', info4: '临时停车位数' },
                        { info1: 'fixedCarports', info2: '是', info3: 'String', info4: '固定车位数' },
                        { info1: 'thirdVipCarports', info2: '是', info3: 'String', info4: '第三方VIP车位数' },
                        { info1: 'inPassagewayTimes', info2: '是', info3: 'String', info4: '进口数量' },
                        { info1: 'outPassagewayTimes', info2: '是', info3: 'String', info4: '出口数量' },
                        { info1: 'validStatus', info2: '是', info3: 'String', info4: '停车场有效状态，1 INVALID：已下线，0 VALID 上线' },
                        { info1: 'publishDate', info2: '是', info3: 'String', info4: '发布、上线时间' },
                        { info1: 'isOpen', info2: '是', info3: 'String', info4: '1:OPEN,0:CLOSE' },
                        { info1: 'isFree', info2: '是', info3: 'String', info4: '1:FREE,0：CHARGE' },
                        { info1: 'isTemplatePay', info2: '是', info3: 'String', info4: '是否支持临时缴费0:NO不支持,1:支持临时缴费' },
                        { info1: 'chargeRuleSimple', info2: '是', info3: 'String', info4: '简单收费规则描述' },
                        { info1: 'openAirType', info2: '是', info3: 'String', info4: '多选，包含：室内(INDOOR)、室外(OUTDOOR)' },
                        { info1: 'parkingType', info2: '是', info3: 'String', info4: '多选，包含：路外(OUTSIDE_ROAD)、路内(INSIDE_ROAD)' },
                        { info1: 'inOutScheme', info2: '是', info3: 'String', info4: '出入方案包含：无(NONE)、视频一体式控制机(VIDEO)、手持拍照咪表(CAMERA_METER)、手持刷卡咪表(CARD_METER)、固定咪表(FIXED_METER)。' },
                        { info1: 'guideScheme', info2: '是', info3: 'String', info4: '引导方案包含：无(NONE)、超声波(ULTRASONIC)、视频(VIDEO)、红外(RED).' },
                        { info1: 'freeTime', info2: '是', info3: 'String', info4: '免费时长' },
                        { info1: 'isTradecouponOnlinesettle', info2: '是', info3: 'String', info4: '是否支持商家券线上结算 0 ：NO ;1：YES' },
                        { info1: 'getTradeNumber', info2: '是', info3: 'String', info4: '收取交易费用笔数（每天的前 x 笔）' },
                        { info1: 'getTradeNumberRatio', info2: '是', info3: 'String', info4: '交易费用笔数收取比例' },
                        { info1: 'feeRate', info2: '是', info3: 'String', info4: '结算费率' },
                        { info1: 'parkVemsUrl', info2: '是', info3: 'String', info4: '' },
                        { info1: 'leasedCarports', info2: '是', info3: 'String', info4: '租用车位数' },
                        { info1: 'freeCarports', info2: '是', info3: 'String', info4: '免费车位数' },
                        { info1: 'bookedCarports', info2: '是', info3: 'String', info4: '预订车位数' },
                        { info1: 'customParkcode', info2: '是', info3: 'String', info4: '自定义停车场编号' },
                        { info1: 'isDelete', info2: '是', info3: 'String', info4: '是否删除,0未删除,1删除' },
                        { info1: 'flagTag', info2: '是', info3: 'String', info4: '停车场标签,方便查询车场信息' },
                        { info1: 'parkType', info2: '是', info3: 'String', info4: '停车场类型0商场1住宅2商住一体3医院及枢纽4写字楼5社会公共6其它' },
                        { info1: 'stopConnectPlatform', info2: '是', info3: 'String', info4: '是否连接平台(上下架)0下架1上架' },
                        { info1: 'parkingSupervisor', info2: '是', info3: 'String', info4: '停车场负责人' },
                        { info1: 'parkingSupervisorPhone', info2: '是', info3: 'String', info4: '停车场负责人电话' },
                        { info1: 'parkSysType', info2: '是', info3: 'String', info4: '车场系统类型(0 VEMS停车场，1云停车场)' },
                        { info1: 'wechatIds', info2: '是', info3: 'String', info4: '适用公众号id' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkInfo.vue